export default function Timezones(Restangular) {
  'ngInject';

  Restangular.extendModel('timezones', (timezone) => {
    timezone.displayname = `(${timezone.offset}) ${timezone.name}`;
    return timezone;
  });

  return Restangular.service('timezones');
}
